import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { TransaccionesPanel } from "@/components/admin/TransaccionesPanel";
import { paginationSearchSchema } from "@/hooks/use-table-pagination";

export const Route = createFileRoute("/admin/operaciones")({
  validateSearch: zodValidator(
    z.object({
      ...paginationSearchSchema,
      open: z.string().uuid().optional(),
    }),
  ),
  component: TransaccionesPanel,
});
